import { useMemo } from 'react'
import type { Filters, Site } from '../types'

/**
 * An empty `categories` array means "no filter applied — show everything", which is also the
 * app's starting state: every checkbox unchecked, every marker on the map. Checking a box
 * narrows the map to exactly the checked categories; unchecking the last one returns to the
 * unfiltered view rather than emptying the map.
 *
 * Every place that decides whether something is on the map must ask this question the same way,
 * including the synthetic TechOWL aggregate marker that lives outside `sites` — hence the shared
 * helper rather than an inline `includes` per call site.
 */
export function isCategoryVisible(filters: Filters, category: Filters['categories'][number]): boolean {
  return filters.categories.length === 0 || filters.categories.includes(category)
}

export function filterSites(sites: Site[], filters: Filters): Site[] {
  if (filters.categories.length === 0) return sites
  return sites.filter(site => filters.categories.includes(site.category))
}

/** `filters` must be a stable reference (from useState/useReducer) to avoid defeating useMemo. */
export function useFilteredSites(sites: Site[], filters: Filters): Site[] {
  return useMemo(() => filterSites(sites, filters), [sites, filters])
}
